/*  */
import axios from 'axios'
import { rqsPre } from './global.js'
export default {
  install(Vue) {
    // let addrPre = wUrl.host + wUrl.port + wUrl.path
    // Vue.prototype.$addrPre = addrPre // 通用接口前缀
    let addrPre = rqsPre

    //test ak
    Vue.prototype.$testak = () => {    
      var url = '/index.php/ucenter/get_ads'
      axios.post(url, {position: ''}, { headers: { "Content-Type": "application/json" } }).then((res) => {     
        console.log(res.data)
      }).catch(() => {
        console.log('error')
      })
    }

    //渠道商列表
    Vue.prototype.$mcList = (callback, error) => {
      var path = '/dataV/merchant/list'
      var url = addrPre + path
      var param = {}
      getRqs(url, param, callback, error)
    }

    //设备在线情况
    Vue.prototype.$eqOnline = (merchantId, callback, error) => {
      var path = '/dataV/device/onlineCount'
      var url = addrPre + path
      var param = { merchantId: merchantId }
      getRqs(url, param, callback, error)
    }

    //地图数据
    Vue.prototype.$getMapData = (merchantId, province, callback, error) => {
      var path = '/dataV/map/list'
      var url = addrPre + path
      var param = { merchantId: merchantId, province: province == '全国'?'':province}
      getRqs(url, param, callback, error)
    }

    //播报统计月日
    Vue.prototype.$mdPlaySt = (merchantId, type, callback, error) => {
      var path = '/dataV/broadcast/list'
      var url = addrPre + path
      var param = { merchantId: merchantId, type: type }
      getRqs(url, param, callback, error)
    }

    //耗时统计
    Vue.prototype.$costSt = (merchantId, callback, error) => {
      var path = '/dataV/broadcast/spendTime'
      var url = addrPre + path
      var param = { merchantId: merchantId }
      getRqs(url, param, callback, error)
    }

    //设备类型
    Vue.prototype.$getEqTypes = (merchantId, callback, error) => {
      var path = '/dataV/device/typeCount'
      var url = addrPre + path
      var param = { merchantId: merchantId }
      getRqs(url, param, callback, error)
    }

    //设备版本
    Vue.prototype.$getEqVers = (merchantId, callback, error) => {
      var path = '/dataV/device/versionCount'
      var url = addrPre + path
      var param = { merchantId: merchantId }
      getRqs(url, param, callback, error)
    }

    //活跃统计
    Vue.prototype.$activesSt = (merchantId, callback, error) => {
      var path = '/dataV/device/onlineCount24H'
      var url = addrPre + path
      var param = { merchantId: merchantId}
      getRqs(url, param, callback, error)
    }

  

    // 删除设备
    Vue.prototype.$delDv = (id, callback, error) => {
      var path = '/del_device'
      var url = addrPre + path
      var param = { id: id}
      postRqs(url, param, callback, error)
    }

    // 清空设备
    Vue.prototype.$clearDv = (callback, error) => {
      var path = '/clear_device'
      var url = addrPre + path
      var param = {}
      postRqs(url, param, callback, error)
    }

    // 上传url
    Vue.prototype.$ulurl = addrPre + '/upload'

    function timeout() {
      localStorage.token = ''      
      // location.hash = "#/login"
    }

    // json post
    var postRqs = function (url, param, callback, error) {
      var token = localStorage.token ? localStorage.token : ''
      if (!token) timeout()
      // param.language = localStorage.system_lang
      // param.token = token
      axios.post(url, param, { headers: { token: token } }).then((res) => {
        // if (res.data.status == 600) {
        //   timeout()
        // }
        if (callback) {
          callback(res.data)
        }
      }).catch(() => {
        if (error) {
          error()
        }
      })
    }
    var getRqs = function (url, param, callback, error) {
      var token = localStorage.token ? localStorage.token : ''
      if (!token) timeout()
      // param.token = token
      axios.get(url, { headers: { token: token }, params: param }).then(res => {
        // if (res.data.status == 600) {
        //   timeout()
        // }
        if (callback) {
          callback(res.data)
        }
      }).then(res => {
        if (error) {
          error(res)
        }
      })
    }
    /*
    var delRqs = function (url, param, callback, error) {
      var token = localStorage.token ? localStorage.token : ''
      if (!token) timeout()
      // param.token = token
      axios.delete(url, { headers: { token: token }, params: param }).then(res => {
        if (res.data.code == 600) {
          timeout()
        }
        if (callback) {
          callback(res.data)
        }
      }).then(res => {
        if (error) {
          error(res)
        }
      })
    }
    var putRqs = function (url, param, callback, error) {
      var token = localStorage.token ? localStorage.token : ''
      if (!token) timeout()
      // param.token = token
      axios.put(url, param, { headers: { token: token } }).then(res => {
        if (res.data.status == 600) {
          timeout()
        }
        if (callback) {
          callback(res.data)
        }
      }).then(res => {
        if (error) {
          error(res)
        }
      })
    }
    */
  }
}
